<template>
  <v-app>
    <v-navigation-drawer v-model="drawer"
                         v-if="auth.user"
                         app
                         clipped
                         :color="$vuetify.breakpoint.mobile ? 'white' : 'transparent'"
                         floating
                         :mini-variant="miniVariant"
                         class="elevation-0">
      <div class="d-flex flex-column" style="height: 100%;">

        <v-list v-if="$vuetify.breakpoint.mobile" class="py-0">
          <v-list-item :class="$vuetify.breakpoint.mobile ? 'primary' : ''">
            <v-list-item-content>
              <a v-if="logo" href="/me" style="max-width: 200px; max-height: 40px;">
                <v-img :src="logo"
                       height="100%"
                       max-height="40"
                       contain>
                </v-img>
              </a>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        
        <v-list dense shaped>
          <v-list-item-group
            v-model="activePage"
            color="transparent"
          >
            <!-- NEWS AND SETTINGS -->
            <v-subheader>{{ $t('menu.subtitles.newsAndSettings') }}</v-subheader>

            <v-list-item
                link
                @click.prevent="navigate('/me')"
                value="Me"
                :style="activePage === 'Me' ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage === 'Me'}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-house</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('pages.me') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                link
                @click.prevent="navigate('/news')"
                value="News"
                :style="activePage === 'News' ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage === 'News'}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-megaphone</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('pages.news') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                link
                @click.prevent="navigate('/profile')"
                value="Profile"
                :style="activePage === 'Profile' ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage === 'Profile'}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-gear</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('pages.profile') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- NEWS AND SETTINGS -->
            
            <!-- ACTIVITIES -->
            <v-subheader>{{ $t('menu.subtitles.activities') }}</v-subheader>

            <v-list-item
                link
                @click.prevent="navigate('/events')"
                value="Events"
                :style="activePage === 'Events' ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage === 'Events'}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-calendar-check</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('pages.events') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                link
                @click.prevent="navigate('/challenges')"
                value="Challenges"
                :style="activePage === 'Challenges' ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage === 'Challenges'}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-award</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('pages.challenges') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- ACTIVITIES -->
            
            <!-- LIBRARY -->
            <v-subheader>{{ $t('menu.subtitles.library') }}</v-subheader>

            <v-list-item
                v-for="(menu, ndx) in translatedGeneralMenu"
                :key="'library-menu-general-' + menu.identifier + '-' + ndx"
                link
                @click.prevent="navigate('/content/' + menu.identifier)"
                :value="menu.identifier.toString()"
                :style="activePage.toString() === menu.identifier.toString() ? 'background: linear-gradient(90deg, ' + $vuetify.theme.currentTheme.primary + '80, ' + $vuetify.theme.currentTheme.primary + ')!important; color: #ffffff;' : ''"
                :class="{'elevation-1': activePage.toString() === menu.identifier.toString()}"
            >
              <v-list-item-action class="d-flex justify-center align-center">
                <v-icon small>fal fa-circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ menu.translation ? menu.translation.title : '' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- LIBRARY -->
            
          </v-list-item-group>
        </v-list>

        <v-spacer></v-spacer>

        <v-list nav dense>
          <v-list-item v-if="!miniVariant">
            <v-list-item-content class="text-center">
              <v-list-item-subtitle>Move To Happiness</v-list-item-subtitle>
              <v-list-item-subtitle>&copy; {{ new Date().getFullYear() }} - {{ version }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$vuetify.breakpoint.mobile && !miniVariant">
            <v-list-item-content class="text-center">
              <m2h-locale-changer :active-page="activePage" :current-user="auth.user"></m2h-locale-changer>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.prevent="toggleMiniVariant()">
            <v-list-item-action class="d-flex justify-center align-center">
              <v-icon small>fal fa-{{ `chevron-${miniVariant ? 'right' : 'left'}` }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title/>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </div>

    </v-navigation-drawer>

    <v-app-bar app
               clipped-left
               dark
               color="primary">

      <v-app-bar-nav-icon v-if="!drawer" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="d-flex justify-start align-center">

        <a href="/" style="max-width: 230px; max-height: 60px;" v-if="!$vuetify.breakpoint.mobile">
          <v-img v-if="logo" 
                 :src="logo"
                 height="100%"
                 max-height="60"
                 contain>
          </v-img>
        </a>

<!--        <v-divider vertical
                   class="mx-3"
                   v-if="!$vuetify.breakpoint.mobile"
        >
        </v-divider>
          
        <v-toolbar-title v-if="activeTitle === 'Content' || activeTitle === 'Challenges Detail'" class="mx-3">{{ title }}</v-toolbar-title>
        <v-toolbar-title v-else class="mx-3">{{ $t('pages.' + title.toLowerCase()) }}</v-toolbar-title>-->
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex justify-end align-center">
        <m2h-locale-changer v-if="!$vuetify.breakpoint.mobile" :active-page="activePage" :current-user="auth.user"></m2h-locale-changer>
        <v-menu
          offset-y
          v-if="auth.user"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              text
              class="rounded-lg"
              v-bind="attrs"
              v-on="on">
              <span v-if="!$vuetify.breakpoint.mobile">{{ auth.user.email }}</span>
              <v-icon
                v-if="$vuetify.breakpoint.mobile"
                small
              >
                fas fa-user
              </v-icon>
              <v-icon right
                      dark
                      x-small>
                fa-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item link @click.prevent="navigate('/profile')">
              <v-list-item-content>
                <v-list-item-title>{{ $t('menu.profile') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link @click.prevent="logout()">
              <v-list-item-content>
                <v-list-item-title>{{ $t('menu.logout') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>
    </v-app-bar>

    <v-main>
      <m2h-loader></m2h-loader>
      <m2h-snackbar></m2h-snackbar>
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
  import i18n from "@/services/i18n";
  import api from "@/api/api";

  export default {
    i18n: i18n,
    name: "m2h-authenticated-layout",
    props: ['siteId', 'title', 'activePage', 'activeTitle', 'user', 'siteName', 'version'],

    data() {
      return {
        miniVariant: false,
        drawer: false,
        auth: {
          user: null,
        },
        structures: [],
        structureGeneral: [],
        logo: ''
      }
    },
    
    computed: {
      translatedGeneralMenu() {
        let menu = [...this.structureGeneral]
        if (menu.length){
          menu.forEach((item) => {
            if (item.asset && item.asset.assetTranslations.length){
              item.asset.properties.menuTitle = item.asset.assetTranslations[0].title
              if (item.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
                item.translation = item.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
              } else if(item.asset.assetTranslations.find((t) => t.default === true)){
                item.translation = item.asset.assetTranslations.find((t) => t.default === true)
              } else {
                item.translation = item.asset.assetTranslations[0]
              }
            }
          })
        }
        return menu
      }
    },

    mounted() {
      let miniVariant = localStorage.getItem('M2H.miniVariant')
      if (this.$vuetify.breakpoint.mobile){ this.drawer = false }
      if (!this.$vuetify.breakpoint.mobile) { this.drawer = true }
      if (miniVariant === 'false'){ this.miniVariant = false }
      if (miniVariant === 'true'){ this.miniVariant = true }
      this.auth.user = JSON.parse(this.user)
      this.checkCompanyBranding()
      this.fetchStructureMenuGeneral()
      //this.fetchStructureMenu(this.$i18n.locale)
    },

    methods:{
      async checkCompanyBranding(){
        if (this.auth.user.organization.metaData.companyBrandingTheme){
          let theme = this.auth.user.organization.metaData.themes.light
          this.$vuetify.theme.currentTheme.primary = theme.primary
          this.$vuetify.theme.currentTheme.secondary = theme.secondary
          this.$vuetify.theme.currentTheme.accent = theme.accent
          this.$vuetify.theme.currentTheme.error = theme.error
          this.$vuetify.theme.currentTheme.info = theme.info
          this.$vuetify.theme.currentTheme.success = theme.success
          this.$vuetify.theme.currentTheme.warning = theme.warning
        }
        if (this.auth.user.organization.metaData.companyBrandingLogo){
          let logoUrl = await this.fetchImage(this.auth.user.organization.metaData.logoId)
          this.logo = logoUrl
        } else {
          this.logo = '/assets/img/logo_wit.png'
        }
      },
      
      navigate(route){
        this.$root.$emit('m2h-loader-show')
        window.location.href = route
      },
      async logout() {
        window.location.href = "/logout"
      },
      toggleMiniVariant(){
        this.miniVariant = !this.miniVariant
        localStorage.setItem('M2H.miniVariant', this.miniVariant)
      },

      async fetchStructureMenu(lang){
          this.isLoading = true
          let structures = await api.structures.getStructureMenuByLanguage(lang).then((res) => { return res.data })
          if (structures){
              this.structures = structures.sort((a, b) => { return a.order - b.order })
          }
          this.isLoading = false
      },
      
      async fetchStructureMenuGeneral(){
          this.isLoading = true
          let structureGeneral = await api.contentStructures.getStructureMenuGeneral().then((res) => { return res.data })
          if (structureGeneral){
            this.structureGeneral = structureGeneral
          }
          this.isLoading = false
      },

      async fetchImage(id){
        if (id){
          return await api.media.getOrganizationlogosSas(id)
              .then((res) => {
                return res.data
              })
              .catch(() => {
                return ''
              })
        } else {
          return ''
        }
      },
    }
  };
</script>

<style lang="scss">

  .v-application {
    font-family:  'Poppins', sans-serif !important;
  }
  .v-main {
    //background-color: #F4F6F9;
    //background-color: #D7D1E1;
    background-color: #F5F5F5;
  }
  /*.v-list-item__title {
    color: #0D47A1;
  }*/

  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 35px !important;
  }

  .v-dialog--fullscreen {
    border-radius: 0 !important;
    margin: 0 !important;
    height: calc(100% - 65px) !important;
    position: fixed;
    overflow-y: auto;
    top: 65px !important;
    left: 0 !important;
  }

</style>
